import { useRecoilValue } from "recoil";
import { PERMISSIONS, ROLES } from "../config";
import { userInfo, userPermissions, userRoles } from "../config/recoil/atoms";

export const usePermissions = () => {
    const userAuthority = useRecoilValue(userRoles) as string[];
    const userId = useRecoilValue(userInfo) as any;
    const permissions = useRecoilValue(userPermissions);

    const hasUserAuthority = () => {
        return userAuthority.length > 0;
    };

    const checkPermission = (permission: PERMISSIONS) => {
        return permissions.includes(permission.valueOf());
    };

    const checkRole = (role: ROLES) => {
        return userAuthority.includes(role.valueOf());
    };

    const checkAssignableContact = () => checkRole(ROLES.CREDIT_AGENT) || checkRole(ROLES.REAL_ESTATE_AGENT) || checkRole(ROLES.LOAN_OFFICER) || checkRole(ROLES.TELEMARKETER) || checkRole(ROLES.CUSTOMER_SERVICE_REP);

    return {
        checkAssignableContact,
        hasUserAuthority,
        checkPermission,
        checkRole,
    };
};
